import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='Ryan Hill'
        dateTime='2023-04-18'
        tag='Policy'
        title='$0 Sales Tax, Seller Permits, and Resale Certificates'
      >
        <p>
          Buying and selling on OneShop is for resale purposes. Your state likely makes it easy to pay $0 in sales tax
          by using a resale certificate.
        </p>
        <p>
          The process varies based on the state of your shipping address. After registering with your state, you can
          fill out the certificate in our mobile app.
        </p>
        <p>
          Please note that sales tax exemption only applies to items intended for resale, and all items purchased for
          personal use are subject to retroactive taxation.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
